





















































































































import { Component, Ref, Vue } from "vue-property-decorator";
import { DevicesModule } from "@/store/modules/DevicesModule";
import { GenericDeviceFilter } from "@/data/models/DeviceFilter";
import {
  getUpdatedCategoryAndTemplateIds,
  getTemplateIdFromSerialNumber,
  isIresCategory,
  isIresTemplate,
  isUnknownCategory,
  isUnknownTemplate,
  removeTemplate,
} from "@/data/models/DeviceSettingsManager";
import DeviceTemplateItem from "@/components/allDevices/DeviceTemplateItem.vue";
import router from "@/router/router";
import { getActiveUser, getDefaultBranchFilterOfUser } from "@/data/repository/UserRepository";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import EditCategoryDialog from "@/components/settings/devices/categories/EditCategoryDialog.vue";
import BaseDialog from "@/components/common/BaseDialog.vue";
import DeviceTemplateDialog from "@/components/allDevices/DeviceTemplateDialog.vue";
import { DeviceTemplate } from "@/data/models/DeviceTemplate";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";
import { observeDeviceOverviews } from "@/data/repository/AllDevicesRepository";
import { filterRetainedDevices, getNumberOfRetainedDevices } from "@/utils/DeviceManagementUtils";
import { DeviceOverview } from "@/data/models/DeviceOverview";
import ClientPanel from "@/data/models/ClientPanel";
import { observeClientPanels } from "@/data/repository/ClientPanelRepository";
import { defineCategoriesAndTemplatesClientAccess } from "@/permissions/ClientPermissions";
import { editIresCategoriesAndTemplatesAccess } from "@/permissions/UserPermissions";
import { DeviceCategoriesAndTemplatesModule } from "@/store/modules/DeviceCategoriesAndTemplatesModule";
import { StateChanger } from "vue-infinite-loading";
import { COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";

@Component({
  methods: { isIresTemplate },
  computed: {
    GenericDeviceFilter() {
      return GenericDeviceFilter;
    },
  },
  components: {
    ConfirmationDialog,
    DeviceTemplateDialog,
    BaseDialog,
    EditCategoryDialog,
    "category-template-item": DeviceTemplateItem,
  },
})
export default class DeviceTemplateList extends Vue {
  infiniteId = new Date();
  pageSize = 20;
  categoryId = "";
  selectedDeviceFilter = GenericDeviceFilter.ALL_DEVICES;
  selectedBranchFilter = getDefaultBranchFilterOfUser();
  iconResource = "mdi-cog-box";
  subscriptions: Array<() => void> = [];
  componentActive = false;
  errorSnackbar = false;
  errorSnackbarText = "";
  successSnackbar = false;
  successSnackbarText = "";

  retrievedClientPanels: ClientPanel[] = [];
  retrievedDeviceOverviews: DeviceOverview[] = [];

  private sliceLength = 20;

  @Ref("confirmDialog")
  confirmationDialog: ConfirmationDialogComponent;

  @Ref("editDialog")
  editCategoryDialog!: EditCategoryDialog;

  @Ref("deviceTemplateDialog")
  deviceTemplateDialog!: DeviceTemplateDialog;

  /** Table header background, theme-aware so it stays readable in dark mode. */
  get tableHeaderColor() {
    return themed(COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK);
  }

  get clientPanels() {
    return this.retrievedClientPanels;
  }

  get categories() {
    return DevicesModule.selectedCategories;
  }

  get isAllowedToDefineOwnDeviceCategoriesAndTemplates() {
    return defineCategoriesAndTemplatesClientAccess();
  }

  get sharedDeviceSettingsJson() {
    return DeviceCategoriesAndTemplatesModule.sharedDeviceCategoriesAndTemplates;
  }

  get localDeviceSettingsJson() {
    return DeviceCategoriesAndTemplatesModule.localDeviceCategoriesAndTemplates;
  }

  get deviceSettingsJson() {
    return this.isAllowedToDefineOwnDeviceCategoriesAndTemplates
      ? this.localDeviceSettingsJson
      : this.sharedDeviceSettingsJson;
  }

  isIresCategory(categoryId: string) {
    return isIresCategory(categoryId);
  }

  isIresTemplate(templateId: string) {
    return isIresTemplate(templateId);
  }

  isUnknownCategory(categoryId: string) {
    return isUnknownCategory(categoryId);
  }

  isUnknownTemplate(templateId: string) {
    return isUnknownTemplate(templateId);
  }

  setToolbarTitle() {
    const baseTitle = this.$t("pages.settings").toString();
    const currentPageTitle = this.selectedCategory?.categoryName ?? "";
    const toolbarTitle = baseTitle +
      " > " + 
      this.$t("settings.hyDryDevice.devicesCategorySettings").toString() + 
      " > " +
      currentPageTitle;


    ToolbarContentModule.setToolbarTitle(toolbarTitle);
  }

  async deleteTemplate(id: string) {
    if (this.getDevicesWithTemplate(id).length > 0) {
      this.onError("allDevices.errorDeviceTemplateHasDevices");
    }
    
    const templateName = this.deviceTemplates.find(cat => cat.id == id)?.deviceName;
    
    if (!templateName) {
      return;
    }
    
    const result = await this.confirmationDialog.show({
      title: this.$t("allDevices.deleteTemplateConfirmTitle", [templateName]).toString(),
      message: this.$t("allDevices.deleteTemplateConfirmMessage", [templateName]).toString(),
      acceptMessage: this.$t("common.delete").toString(),
    });
    
    const deviceSettings = this.deviceSettingsJson;
    
    if (result && deviceSettings) {
      await removeTemplate(this.categoryId, id, deviceSettings);
      this.showSuccessSnackbar("allDevices.deviceTemplateDeleted");
    }
  }

  showNewTemplateDialog() {
    this.deviceTemplateDialog.show({ 
      isNew: true, 
      categoryTemplate: this.selectedCategory
    });
  }

  showTemplateDialog(template: DeviceTemplate) {
    const isEditable = (!isIresTemplate(template.id) || this.isAllowedToEditIresCategoriesAndTemplates) && this.isAllowedToEditOrDeleteTemplate && !isUnknownTemplate(template.id);
    const restrictEditing = this.getDevicesWithTemplate(template.id).length > 0;

    this.deviceTemplateDialog.show({ 
      template: template, 
      isEditable: isEditable,
      restrictEditing: restrictEditing,
      categoryTemplate: this.selectedCategory,
      hideSaveButton: !isEditable
    });
  }

  onError(data: string) {
    this.showErrorSnackbar(data);
  }

  onSuccess(data: string) {
    this.showSuccessSnackbar(data);
  }

  showErrorSnackbar(message: string) {
    this.errorSnackbar = true;
    this.errorSnackbarText = message;
  }

  showSuccessSnackbar(message: string) {
    this.successSnackbar = true;
    this.successSnackbarText = message;
  }

  get isDefaultBranchFilterSelected() {
    return this.selectedBranchFilter.isDefaultBranchFilter();
  }

  get deviceOverviews() {
    return this.retrievedDeviceOverviews;
  }

  get showInfiniteLoading() {
    return this.deviceTemplates.length > 0;
  }

  /**
   * Iterates over each device overview, updating the category and template IDs based on shared device settings.
   * This method leverages the `getUpdatedCategoryAndTemplateIds` function to find the updated category and template IDs
   * from the shared device settings that correspond to the local settings for each device. It then updates these IDs
   * in the device overview list.
   *
   * @returns {DeviceOverview[]} An array of device overview objects with updated category and template IDs.
   */
  get deviceOverviewsWithUpdatedCategoryAndTemplateIds() {
    const deviceOverviews = this.deviceOverviews;

    deviceOverviews.forEach((device) => {
      const { updatedCategoryId, updatedTemplateId } = getUpdatedCategoryAndTemplateIds(
        device.categoryId,
        device.templateId,
        this.localDeviceSettingsJson,
        this.sharedDeviceSettingsJson,
        device.devicePowerUsageType ?? undefined,
      );

      device.categoryId = updatedCategoryId;
      device.templateId = updatedTemplateId;
    });

    return deviceOverviews;
  }

  get deviceTemplates() {
    return this.selectedCategory
        ? this.selectedCategory.deviceTemplates
        : [];
  }

  get selectedCategory() {
    return this.deviceSettingsJson.deviceCategories.find((cat) => cat.id === this.categoryId) ?? null;
  }

  get showNoDevicesMessage() {
    return this.deviceTemplates.length <= 0;
  }

  get isAllowedToEditOrDeleteTemplate() {
    return defineCategoriesAndTemplatesClientAccess();
  }

  get isAllowedToEditIresCategoriesAndTemplates() {
    return editIresCategoriesAndTemplatesAccess(getActiveUser());
  }

  resetDisplayedTemplates() {
    this.sliceLength = this.pageSize;
    this.infiniteId = new Date();
  }

  isRemovable(templateId: string) {
    return this.getDevicesWithTemplate(templateId).length <= 0 && !isIresTemplate(templateId);
  }

  sliceTemplatesToDisplay(length: number) {
    const deviceTemplates = this.deviceTemplates;

    return deviceTemplates.slice(0, length);
  }

  async infiniteHandler(data: StateChanger) {
    const nextSliceLength = this.sliceLength + this.pageSize;
    const nextSlice = this.sliceTemplatesToDisplay(nextSliceLength);

    this.sliceLength = nextSliceLength;

    if (nextSliceLength > nextSlice.length) {
      data.complete();
    } else {
      data.loaded();
    }
  }

  get templatesToDisplay() {
    return this.sliceTemplatesToDisplay(this.sliceLength);
  }

  getDevicesWithTemplate(deviceTemplateId: string) {
    if (isIresTemplate(deviceTemplateId)) {
      const clientPanels = this.clientPanels.filter((panel) => {
        return getTemplateIdFromSerialNumber(panel.serialNumber) === deviceTemplateId;
      });

      return filterRetainedDevices(clientPanels);
    }

    const deviceOverviews = this.deviceOverviewsWithUpdatedCategoryAndTemplateIds;

    return deviceOverviews.filter((deviceOverview) => deviceOverview.templateId === deviceTemplateId && deviceOverview.availability !== -1)
  }

  getNoOfTotalDevices(devices: (DeviceOverview | ClientPanel)[]) {
    return getNumberOfRetainedDevices(devices);
  }

  async created() {
    this.categoryId = router.currentRoute.params["categoryId"];

    this.subscriptions.push(observeDeviceOverviews(
      (deviceOverview: Array<DeviceOverview>) => {
        this.retrievedDeviceOverviews = deviceOverview;
      }
    ));

    this.subscriptions.push(observeClientPanels(
      (clientPanels: Array<ClientPanel>) => {
        this.retrievedClientPanels = clientPanels;
      }
    ));
    
    this.setToolbarTitle();
    this.componentActive = true;
  }

  destroyed() {
    this.componentActive = false;
  }

  mounted() {
    this.setToolbarTitle();
  }
}
